<template>
	<!-- Affichage des notifications (transition-group permet de les animer https://fr.vuejs.org/v2/guide/transitions.html) -->
    <transition-group name="notifications" class="notifications" tag="div" :class="`notifications-${position}`">
        <notification
            v-for="notification in app.notifications"
            :key="notification.id"
            :notification="notification"
            :position="position"
        />
    </transition-group>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "./notification.vue";

export default {
	components: { notification },
	name: "NotificationsGroup",
	props: {
		position: {
			type: String,
			default: "fixed"
		}
	},
	computed: {
		...mapGetters(["app"])
	},
};
</script>

<style lang="stylus" scoped>
.notifications
	position fixed
	right 16px
	top 16px
	z-index 10005
.notifications-enter, .notifications-leave-to
	opacity 0
	transform translateX(100%)
.notifications-leave-active
	position absolute
.notifications-absolute
	position absolute
</style>
